import styled from "styled-components";

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.colors.background};
  border-bottom: ${(props) => (props.$noBorder ? 'none' : `1px solid ${props.theme.colors.border}`)};
  gap: 8px;
  margin-bottom: 12px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.2s ease;
  padding: ${(props) => (props.$isExpanded ? '0' : '0 0 8px 0')};
`;

export const CardHeaderLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex: 1;
`;

export const CardHeaderRight = styled.div`
  display: flex;
  align-items: center;
`;

export const CardContent = styled.div`
  display: ${(props) => (props.$isExpanded ? 'flex' : 'none')};
  flex-direction: column;
  gap: 3px;
  padding: 12px 16px 12px 16px;
  padding-right: 0;
  align-items: stretch;
  width: 100%;

  & > * {
    width: 100%;
  }

  ul{
    padding-left: 15px;
  }

  p {
    margin: 0;
    padding: 0;
  }
`;

export const ChevronWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
  transform: ${(props) => (props.$isExpanded ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

export const CardHeaderContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const HeaderLeftColumn = styled.div`
  width: 90%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

export const HeaderRightColumn = styled.div`
  width: 10%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
`;

export const SwitchIconLabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const TitleDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SwitchTitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

